/* NELA storefront behavior: header, wall filters, phone swipe rows, product options.
   Ported from the 2026 site mockup (08 Website/mockup). */
(function () {
  /* Header: mode toggle, stuck border, phone menu */
  /* mode.js loads async and can finish after this file (often on phones), so
     the toggle is handled by one listener that looks NelaMode up on click */
  if (window.NelaMode) window.NelaMode.apply();
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-mode-toggle]');
    if (b && window.NelaMode) window.NelaMode.toggle();
  });

  var nav = document.querySelector('.nav');
  if (nav) {
    var stick = function () {
      nav.classList.toggle('stuck', window.scrollY > 4);
    };
    window.addEventListener('scroll', stick, { passive: true });
    stick();
  }

  var mmBtn = document.querySelector('.mm-btn');
  var mmPanel = document.getElementById('mm-panel');
  if (mmBtn && mmPanel) {
    var setMenu = function (open) {
      mmPanel.hidden = !open;
      mmBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      mmBtn.textContent = open ? mmBtn.dataset.openLabel : mmBtn.dataset.label;
    };
    mmBtn.addEventListener('click', function () {
      setMenu(mmPanel.hidden);
    });
    mmPanel.addEventListener('click', function (e) {
      if (e.target.closest('a')) setMenu(false);
    });
    /* Tapping anywhere outside the open menu (or pressing Esc) closes it */
    document.addEventListener('click', function (e) {
      if (!mmPanel.hidden && !mmPanel.contains(e.target) && !mmBtn.contains(e.target)) setMenu(false);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !mmPanel.hidden) {
        setMenu(false);
        mmBtn.focus();
      }
    });
  }

  /* Colour names in the visitor's language ("Royal Blue" -> "Azul rey"); Shopify keeps
     the English values, which the theme matches on. Map comes from the cart drawer. */
  var COLORS = {};
  try {
    COLORS = JSON.parse(document.getElementById('nela-colors').textContent);
  } catch (e) {}
  function colorLabel(c) {
    return COLORS[c] || c;
  }
  /* Storefront root for the visitor's language: '/' or '/es/' */
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  initWall();
  initStance();
  initProduct();
  initCart();
  initSizeGuide();
  initPageNav();
  initLooks();
  initContact();
  initLangPrompt();

  /* Looks: landscape images span the full width, portraits pair up two across */
  function initLooks() {
    var wrap = document.querySelector('.looks');
    if (!wrap) return;
    wrap.querySelectorAll('img').forEach(function (img) {
      var tile = img.closest('.looks > *') || img;
      function mark() {
        var w = img.naturalWidth || +img.getAttribute('width');
        var h = img.naturalHeight || +img.getAttribute('height');
        if (w && h) tile.classList.toggle('wide', w > h * 1.05);
      }
      if (img.getAttribute('width') && img.getAttribute('height')) mark();
      if (img.complete) mark(); else img.addEventListener('load', mark);
      img.addEventListener('load', solo);
    });
    solo();

    /* A portrait left without a partner (before a wide image or at the end) is centered on its own row */
    function solo() {
      var run = [];
      var tiles = Array.prototype.slice.call(wrap.children).filter(function (t) { return t.querySelector('img'); });
      tiles.forEach(function (t) { t.classList.remove('solo'); });
      tiles.concat([null]).forEach(function (t) {
        if (t && !t.classList.contains('wide')) { run.push(t); return; }
        if (run.length % 2) run[run.length - 1].classList.add('solo');
        run = [];
      });
    }

    initLookShop(wrap);
    initLightbox(wrap);
    initPhoneCrops(wrap);
  }

  /* Looks on phones: data-m="w:h;fx;fy;zoom" frames a look tighter around the person
     (frame ratio, focus point in % of the photo, extra zoom). Desktop shows the whole photo. */
  function phoneQuery() { return window.matchMedia('(max-width: 760px)'); }
  function cropOf(tile) {
    var m = tile.getAttribute('data-m');
    if (!m || !phoneQuery().matches) return null;
    var p = m.split(';');
    var r = p[0].split(':');
    return { ratio: +r[0] / +r[1], fx: +p[1] / 100, fy: +p[2] / 100, z: +p[3] || 1 };
  }
  function initPhoneCrops(wrap) {
    function apply() {
      wrap.querySelectorAll('[data-m]').forEach(function (tile) {
        var c = cropOf(tile);
        var img = tile.querySelector('img');
        tile.classList.toggle('cropped', !!c);
        /* Pre-cropped phone file (data-crop): the photo already is the framed region */
        if (c && tile.dataset.crop) {
          tile.style.setProperty('--crop-ratio', c.ratio);
          img.style.objectPosition = img.style.transformOrigin = img.style.transform = '';
        } else if (c) {
          tile.style.setProperty('--crop-ratio', c.ratio);
          img.style.objectPosition = c.fx * 100 + '% ' + c.fy * 100 + '%';
          img.style.transformOrigin = c.fx * 100 + '% ' + c.fy * 100 + '%';
          img.style.transform = c.z !== 1 ? 'scale(' + c.z + ')' : '';
        } else {
          img.style.objectPosition = img.style.transformOrigin = img.style.transform = '';
        }
        placeSpots(tile);
      });
    }
    apply();
    var mq = phoneQuery();
    if (mq.addEventListener) mq.addEventListener('change', apply);
    window.addEventListener('resize', function () {
      wrap.querySelectorAll('.looks > *').forEach(placeSpots);
    });
    wrap.querySelectorAll('img').forEach(function (img) {
      img.addEventListener('load', function () { placeSpots(img.closest('.looks > *')); });
    });
  }
  /* keep each dot on its garment when the photo is cropped/zoomed on phones */
  function placeSpots(tile) {
    if (!tile) return;
    var spots = tile.querySelectorAll('.look-spot');
    if (!spots.length) return;
    var img = tile.querySelector('img');
    var c = cropOf(tile);
    var cw = img.clientWidth, ch = img.clientHeight;
    var nw = img.naturalWidth || +img.getAttribute('width');
    var nh = img.naturalHeight || +img.getAttribute('height');
    Array.prototype.forEach.call(spots, function (sp) {
      if (c && tile.dataset.crop) {
        /* dot position inside the pre-cropped region (in % of the region) */
        var r = tile.dataset.crop.split(';').map(Number);
        var fw = +img.getAttribute('width'), fh = +img.getAttribute('height');
        var px = ((sp._x / 100) * fw - r[0]) / r[2], py = ((sp._y / 100) * fh - r[1]) / r[3];
        sp.hidden = px < 0.03 || py < 0.03 || px > 0.97 || py > 0.97;
        sp.style.left = px * 100 + '%';
        sp.style.top = py * 100 + '%';
        sp.classList.toggle('flip', px > 0.55);
        return;
      }
      if (!c || !cw || !nw) {
        sp.style.left = sp._x + '%';
        sp.style.top = sp._y + '%';
        sp.hidden = false;
        return;
      }
      var k = Math.max(cw / nw, ch / nh), w = nw * k, h = nh * k;
      var x = (cw - w) * c.fx + (sp._x / 100) * w;
      var y = (ch - h) * c.fy + (sp._y / 100) * h;
      x = c.fx * cw + (x - c.fx * cw) * c.z;
      y = c.fy * ch + (y - c.fy * ch) * c.z;
      sp.hidden = x < 8 || y < 8 || x > cw - 8 || y > ch - 8;
      sp.style.left = (x / cw) * 100 + '%';
      sp.style.top = (y / ch) * 100 + '%';
      sp.classList.toggle('flip', x / cw > 0.55);
    });
  }

  /* Looks: "Shop this look" links from each tile's data-shop="handle:Color,handle:Color" */
  function initLookShop(wrap) {
    var cache = {};
    function product(handle) {
      if (!cache[handle]) {
        cache[handle] = fetch(ROOT + 'products/' + handle + '.js').then(function (r) {
          return r.ok ? r.json() : null;
        });
      }
      return cache[handle];
    }
    /* '"NELA" by Chaz Bojórquez Lettering T-Shirt' -> 'Chaz T-Shirt';
       Spanish 'Playera "NELA" by Chaz Bojórquez' -> 'Playera Chaz' */
    function shortName(title) {
      var line = /Chaz/.test(title) ? 'Chaz' : /Original/.test(title) ? 'Original' : '';
      if (/\b(Lettering|Logo)\s+/.test(title)) return (line ? line + ' ' : '') + title.replace(/^.*\b(Lettering|Logo)\s+/, '');
      var garment = title.split(/\s+(?:con logo|")/)[0].replace(' gruesa de cuello redondo', '');
      return garment + (line ? ' ' + line : '');
    }
    wrap.querySelectorAll('[data-shop]').forEach(function (tile) {
      /* "handle:Color@x;y" - x;y = where the garment sits, in % of the photo */
      var picks = tile.getAttribute('data-shop').split(',').map(function (s) {
        var at = s.split('@');
        var i = at[0].lastIndexOf(':');
        var xy = at[1] ? at[1].split(';') : null;
        return {
          handle: at[0].slice(0, i).trim(),
          color: at[0].slice(i + 1).trim(),
          x: xy ? parseFloat(xy[0]) : null,
          y: xy ? parseFloat(xy[1]) : null
        };
      });
      Promise.all(picks.map(function (p) { return product(p.handle); })).then(function (list) {
        /* one chip per product: colour-matched thumbnail, short name, colour and price */
        var chips = [];
        list.forEach(function (prod, i) {
          if (!prod) return;
          var color = picks[i].color;
          var v = prod.variants.filter(function (x) { return x.option1 === color && x.available; })[0] ||
            prod.variants.filter(function (x) { return x.option1 === color; })[0];
          var name = shortName(prod.title);
          var a = document.createElement('a');
          a.className = 'look-chip';
          a.href = prod.url + (v ? '?variant=' + v.id : '');
          a.setAttribute('aria-label', wrap.dataset.shopLabel + ': ' + name + (v ? ', ' + colorLabel(color) : ''));
          var src = (v && v.featured_image && v.featured_image.src) || prod.featured_image;
          if (src) {
            var pic = document.createElement('img');
            pic.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=120';
            pic.alt = '';
            pic.width = 44;
            pic.height = 44;
            pic.loading = 'lazy';
            a.appendChild(pic);
          }
          var txt = document.createElement('span');
          var b = document.createElement('b');
          b.textContent = name;
          var sub = document.createElement('span');
          sub.textContent = (v ? colorLabel(color) + ' · ' : '') + '$' + ((v ? v.price : prod.price) / 100).toFixed(2);
          txt.appendChild(b);
          txt.appendChild(sub);
          a.appendChild(txt);
          a._pick = i;
          chips.push(a);
        });
        if (!chips.length) return;
        var box = null;
        chips.forEach(function (a) {
          var p = picks[a._pick];
          if (p.x === null) {
            /* no position given: chip sits in the photo's bottom-left corner */
            if (!box) {
              box = document.createElement('span');
              box.className = 'look-shop';
              tile.appendChild(box);
            }
            box.appendChild(a);
            return;
          }
          /* a dot on the garment; its chip shows on hover (desktop) or tap (phones) */
          var spot = document.createElement('span');
          spot.className = 'look-spot' + (p.x > 55 ? ' flip' : '');
          spot.style.left = p.x + '%';
          spot.style.top = p.y + '%';
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'look-dot';
          dot.setAttribute('aria-label', a.getAttribute('aria-label'));
          dot.setAttribute('aria-expanded', 'false');
          spot.appendChild(dot);
          spot.appendChild(a);
          spot._x = p.x;
          spot._y = p.y;
          tile.appendChild(spot);
        });
        placeSpots(tile);
      });
    });

    /* tap a dot to open its chip; tap anywhere else to close */
    function closeSpots(except) {
      wrap.querySelectorAll('.look-spot.open').forEach(function (sp) {
        if (sp === except) return;
        sp.classList.remove('open');
        sp.querySelector('.look-dot').setAttribute('aria-expanded', 'false');
      });
    }
    wrap.addEventListener('click', function (e) {
      var dot = e.target.closest('.look-dot');
      if (!dot) { if (!e.target.closest('.look-chip')) closeSpots(); return; }
      e.stopPropagation();
      var sp = dot.parentNode;
      closeSpots(sp);
      var on = !sp.classList.contains('open');
      sp.classList.toggle('open', on);
      dot.setAttribute('aria-expanded', on ? 'true' : 'false');
    }, true);
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.looks')) closeSpots();
    });
  }

  /* Looks: tap a look to see it full screen; swipe, arrows or arrow keys to move, Esc / ✕ / backdrop to close */
  function initLightbox(wrap) {
    var lb = document.getElementById('lb');
    if (!lb) return;
    var img = lb.querySelector('.lb-img');
    var cap = lb.querySelector('.lb-cap');
    var imgs = Array.prototype.slice.call(wrap.querySelectorAll('img'));
    var at = 0;
    var opener = null;

    imgs.forEach(function (im, i) {
      im.setAttribute('tabindex', '0');
      im.setAttribute('role', 'button');
      im.setAttribute('aria-label', wrap.dataset.viewLabel + ': ' + (im.alt || ''));
      im.addEventListener('click', function () { open(i); });
      im.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(i); }
      });
    });

    function show(i) {
      at = (i + imgs.length) % imgs.length;
      var src = imgs[at];
      img.width = +src.getAttribute('width') || src.naturalWidth || 2000;
      img.height = +src.getAttribute('height') || src.naturalHeight || 2000;
      /* the viewer shows the whole photo, not a phone crop */
      img.src = src.closest('picture') && phoneQuery().matches ? src.src : src.currentSrc || src.src;
      img.alt = src.alt || '';
      cap.textContent = '';
      var p = document.createElement('span');
      /* shoppers see the short data-caption; the long alt text stays for search and screen readers */
      var t = src.closest('.looks > *');
      p.textContent = (t && t.getAttribute('data-caption')) || '';
      cap.appendChild(p);
      var tile = src.closest('.looks > *');
      var found = tile ? tile.querySelectorAll('.look-chip') : [];
      if (found.length) {
        var row = document.createElement('span');
        row.className = 'look-shop';
        Array.prototype.forEach.call(found, function (c) { row.appendChild(c.cloneNode(true)); });
        cap.appendChild(row);
      }
    }
    function open(i) {
      opener = document.activeElement;
      show(i);
      lb.hidden = false;
      document.documentElement.classList.add('lb-open');
      lb.querySelector('.lb-x').focus();
    }
    function close() {
      lb.hidden = true;
      document.documentElement.classList.remove('lb-open');
      if (opener && opener.focus) opener.focus();
    }

    lb.addEventListener('click', function (e) {
      var b = e.target.closest('[data-lb]');
      if (b) {
        var act = b.getAttribute('data-lb');
        if (act === 'close') close(); else show(at + (act === 'next' ? 1 : -1));
        return;
      }
      if (!e.target.closest('.lb-img, .lb-cap a')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowRight') show(at + 1);
      else if (e.key === 'ArrowLeft') show(at - 1);
      else if (e.key === 'Tab') {
        /* keep focus inside the viewer */
        var f = Array.prototype.slice.call(lb.querySelectorAll('button, a[href]'));
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    var x0 = null, y0 = null;
    lb.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) show(at + (dx < 0 ? 1 : -1));
      x0 = null;
    });
  }

  /* Help / Terms side links: underline the section in view; land headings below the sticky header */
  function initPageNav() {
    var links = document.querySelectorAll('.pg aside a[href^="#"]');
    if (!links.length) return;
    var header = document.querySelector('body > .block-container:first-child');
    var items = [];
    links.forEach(function (a) {
      var h = document.getElementById(decodeURIComponent(a.getAttribute('href').slice(1)));
      if (h) items.push({ a: a, h: h });
    });
    var aside = links[0].parentNode;
    function offset() {
      var h = header ? header.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--pg-top', h + 'px');
      var row = window.matchMedia('(max-width: 760px)').matches ? aside.getBoundingClientRect().height : 0;
      return h + row + 24;
    }
    function update() {
      var off = offset();
      var current = items[0];
      items.forEach(function (it) {
        it.h.style.scrollMarginTop = off + 'px';
        if (it.h.getBoundingClientRect().top - off <= 8) current = it;
      });
      if (window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2) current = items[items.length - 1];
      items.forEach(function (it) {
        if (it === current) {
          if (!it.a.hasAttribute('aria-current') && aside.scrollWidth > aside.clientWidth) {
            aside.scrollLeft = it.a.offsetLeft - 16;
          }
          it.a.setAttribute('aria-current', 'true');
        }
        else it.a.removeAttribute('aria-current');
      });
    }
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Size guide pop-up: opens on the product's garment; Inches/CM toggle */
  function initSizeGuide() {
    var ov = document.querySelector('[data-size-guide]');
    var openBtn = document.querySelector('[data-sg-open]');
    if (!ov || !openBtn) return;
    var box = ov.querySelector('.sg');
    function close() { ov.hidden = true; document.documentElement.classList.remove('cd-open'); openBtn.focus(); }
    openBtn.addEventListener('click', function () {
      ov.hidden = false;
      document.documentElement.classList.add('cd-open');
      var h = ov.querySelector('#sg-' + ov.dataset.garment);
      box.scrollTop = h ? h.offsetTop - 60 : 0;
      ov.querySelector('[data-sg-close]').focus();
    });
    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.closest('[data-sg-close]')) close();
      var u = e.target.closest('[data-u]');
      if (!u) return;
      var cm = u.dataset.u === 'cm';
      ov.querySelectorAll('[data-u]').forEach(function (b) { b.setAttribute('aria-pressed', b === u ? 'true' : 'false'); });
      ov.querySelectorAll('[data-in]').forEach(function (td) {
        var v = parseFloat(td.dataset.in);
        td.textContent = cm ? (Math.round(v * 2.54 * 10) / 10).toString() : td.dataset.in;
      });
      ov.querySelectorAll('[data-unit-label]').forEach(function (th) { th.textContent = u.textContent; });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) close(); });
  }

  /* Cart tray: header Cart opens it; Add to cart adds via the Ajax API and opens it */
  function initCart() {
    var ov = document.querySelector('[data-cart-drawer]');
    if (!ov) return;
    var list = ov.querySelector('[data-cart-items]');
    var sub = ov.querySelector('[data-cart-subtotal]');
    var checkout = ov.querySelector('[data-cart-checkout]');
    var labelEl = document.querySelector('[data-cart-label]');
    var base = ov.dataset.cartUrl;
    var cutouts = {};
    try {
      cutouts = JSON.parse(ov.querySelector('[data-cart-cutouts]').textContent);
    } catch (e) {}

    function money(cents) {
      var n = cents / 100;
      return '$' + (n % 1 ? n.toFixed(2) : String(n));
    }
    function esc(t) {
      var d = document.createElement('div');
      d.textContent = t == null ? '' : t;
      return d.innerHTML;
    }
    function setCount(n) {
      if (!labelEl) return;
      var label = labelEl.dataset.cartLabel.replace('__N__', n);
      document.querySelectorAll('[data-cart-open]').forEach(function (a) { a.textContent = label; });
    }
    function render(cart) {
      setCount(cart.item_count);
      sub.textContent = money(cart.total_price);
      checkout.disabled = cart.item_count === 0;
      if (!cart.items.length) {
        list.innerHTML = '<p class="cd-empty">' + esc(ov.dataset.labelEmpty) + '</p>';
        return;
      }
      list.innerHTML = cart.items
        .map(function (it, i) {
          var img = cutouts[it.variant_id] ||
            (it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '');
          var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title.split(' / ').map(colorLabel).join(' / ') : '';
          return (
            '<div class="cd-item">' +
            (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
            '<div><div class="t">' + esc(it.product_title) + '</div>' +
            '<div class="v">' + esc(variant) + '</div>' +
            '<div class="cd-q" aria-label="' + esc(ov.dataset.labelQty) + '">' +
            '<button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="-">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="+">+</button>' +
            '</div></div>' +
            '<div><div>' + money(it.final_line_price) + '</div>' +
            '<button type="button" class="cd-rm" data-line="' + (i + 1) + '" data-q="0">' + esc(ov.dataset.labelRemove) + '</button></div>' +
            '</div>'
          );
        })
        .join('');
    }
    function load() {
      return fetch(base + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(render);
    }
    function open() {
      ov.hidden = false;
      document.documentElement.classList.add('cd-open');
      load();
      var x = ov.querySelector('[data-cart-close]');
      if (x) x.focus();
    }
    function close() {
      ov.hidden = true;
      document.documentElement.classList.remove('cd-open');
    }

    document.querySelectorAll('[data-cart-open]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    ov.addEventListener('click', function (e) {
      if (e.target === ov || e.target.closest('[data-cart-close]')) { close(); return; }
      var b = e.target.closest('[data-line]');
      if (!b) return;
      fetch(ov.dataset.changeUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: +b.dataset.line, quantity: Math.max(0, +b.dataset.q) }),
      })
        .then(function (r) { return r.json(); })
        .then(render);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !ov.hidden) close(); });

    var form = document.querySelector('[data-product-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var add = form.querySelector('[data-add]');
        if (add) add.disabled = true;
        fetch(ov.dataset.addUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return r.json();
          })
          .then(open)
          .catch(function () { form.submit(); })
          .finally(function () { if (add) add.disabled = false; });
      });
    }
  }

  /* Wall: garment and line filters, phone swipe rows, back-button position */
  /* Wall stance line: type the first line, hold, clear it, type the second, repeat.
     Reduced motion shows both lines still. */
  function initStance() {
    var el = document.querySelector('.lines .stance');
    if (!el) return;
    var out = el.querySelector('.stance-type');
    var lines = [].slice.call(el.querySelectorAll('.stance-size')).map(function (s) {
      return s.textContent.trim();
    });
    if (!out || lines.length < 2) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      out.textContent = lines.join(' × ');
      el.classList.add('still');
      return;
    }
    var i = 0;
    var n = lines[0].length;
    var step = function (fn, ms) { setTimeout(fn, ms); };
    var erase = function () {
      n = 0;
      out.textContent = '';
      i = (i + 1) % lines.length;
      step(type, 450);
    };
    var type = function () {
      if (n < lines[i].length) {
        n += 1;
        out.textContent = lines[i].slice(0, n);
        step(type, 65);
      } else {
        step(erase, 2800);
      }
    };
    /* The page loads with the first line already written: hold it, then start */
    step(erase, 2800);
  }

  function initWall() {
    var clicked = null;
    var fans = document.getElementById('fans');
    var secs = [].slice.call(document.querySelectorAll('.sec'));
    if (!fans || !secs.length) return;

    var HEX = { Black: '#161616', White: '#f2f2ef', 'Royal Blue': '#14269a', 'Deep Royal': '#14269a', Asphalt: '#47494a', 'Vintage Brown': '#6e5643', Shadow: '#4a4748', Mocha: '#77574c' };
    var g = 'all';
    var line = 'all';
    var mq = window.matchMedia('(max-width: 640px)');

    fans.innerHTML = secs
      .map(function (s, i) {
        var name = s.querySelector('.head span').textContent;
        var price = s.dataset.price || '';
        var items = [].slice.call(s.querySelectorAll('.wall figure')).map(function (f) {
          var img = f.querySelector('img');
          var a = f.querySelector('a.go');
          return {
            src: img ? img.currentSrc || img.src : '',
            c: f.dataset.color || f.querySelector('.cap span').textContent,
            hex: f.dataset.hex || '',
            href: a ? a.getAttribute('href') : '',
          };
        });
        var order = items.length > 2 ? [items[items.length - 1]].concat(items.slice(0, items.length - 1)) : items;
        var start = items.length > 2 ? 1 : 0;
        return (
          '<div class="fan" data-i="' + i + '" data-g="' + s.dataset.g + '" data-line="' + s.dataset.line + '" data-start="' + start + '">' +
          '<div class="row">' +
          order
            .map(function (it, k) {
              /* Only the first row's centered shirt loads right away; the rest wait until near view */
              var load = i === 0 && k === start ? ' fetchpriority="high"' : ' loading="lazy"';
              return '<button type="button" data-href="' + it.href + '" aria-label="' + it.c + ' ' + name + '"><img src="' + it.src + '" alt="" draggable="false" decoding="async"' + load + '></button>';
            })
            .join('') +
          '</div><div class="dots">' +
          order.map(function () { return '<i></i>'; }).join('') +
          '</div><button type="button" class="lab"><span>' + name + '</span><span class="sw-dots">' +
          items
            .map(function (it) {
              return '<i style="background:' + (it.hex || HEX[it.c] || '#888') + '" title="' + it.c + '"></i>';
            })
            .join('') +
          '<b>' + price + '</b></span></button></div>'
        );
      })
      .join('');

    function open(f) {
      g = f.dataset.g;
      line = f.dataset.line;
      history.replaceState(null, '', '#' + g);
      apply();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    [].forEach.call(fans.querySelectorAll('.fan'), function (f) {
      var row = f.querySelector('.row');
      var btns = [].slice.call(row.children);
      var dots = [].slice.call(f.querySelectorAll('.dots i'));
      var tmr = null, down = false, sx = 0, sl = 0, startK = 0, moved = false, lock = false;

      function mark() {
        var r = row.getBoundingClientRect(), mid = r.left + r.width / 2, best = 0, bd = 1e9;
        btns.forEach(function (b, k) {
          var c = b.getBoundingClientRect();
          var d = Math.abs(c.left + c.width / 2 - mid);
          if (d < bd) { bd = d; best = k; }
        });
        btns.forEach(function (b, k) { b.classList.toggle('on', k === best); });
        dots.forEach(function (d, k) { d.classList.toggle('on', k === best); });
        return best;
      }
      function center(k, smooth) {
        var b = btns[k];
        if (smooth) { lock = true; setTimeout(function () { lock = false; }, 500); }
        row.scrollTo({ left: b.offsetLeft - (row.clientWidth - b.offsetWidth) / 2, behavior: smooth ? 'smooth' : 'auto' });
      }
      f._init = function () { center(+f.dataset.start, false); mark(); };
      function settle() {
        if (down || lock) return;
        var k = mark();
        var b = btns[k];
        var target = b.offsetLeft - (row.clientWidth - b.offsetWidth) / 2;
        if (Math.abs(row.scrollLeft - target) > 2) {
          lock = true;
          row.scrollTo({ left: target, behavior: 'smooth' });
          setTimeout(function () { lock = false; }, 420);
        }
      }
      row.addEventListener('scroll', function () { mark(); clearTimeout(tmr); tmr = setTimeout(settle, 110); }, { passive: true });
      if ('onscrollend' in window) row.addEventListener('scrollend', function () { clearTimeout(tmr); settle(); });
      row.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; sx = e.clientX; sl = row.scrollLeft; startK = mark();
        row.style.scrollSnapType = 'none';
        row.setPointerCapture(e.pointerId);
      });
      row.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - sx;
        if (Math.abs(dx) > 4) moved = true;
        row.scrollLeft = sl - dx;
      });
      row.addEventListener('pointerup', function (e) {
        if (!down) return;
        down = false;
        if (row.hasPointerCapture && row.hasPointerCapture(e.pointerId)) row.releasePointerCapture(e.pointerId);
        if (!moved) {
          /* A click without a drag: open the centered shirt, or center a side one */
          row.style.scrollSnapType = '';
          var hit = document.elementFromPoint(e.clientX, e.clientY);
          var b = hit && hit.closest('.row button');
          if (b && row.contains(b)) {
            if (b.classList.contains('on') && b.dataset.href) { clicked = b.dataset.href; location.href = b.dataset.href; }
            else center(btns.indexOf(b), true);
          }
          return;
        }
        var dx = e.clientX - sx, k = startK;
        if (dx < -30) k = Math.min(btns.length - 1, startK + 1);
        else if (dx > 30) k = Math.max(0, startK - 1);
        center(k, true);
        setTimeout(function () { row.style.scrollSnapType = ''; }, 450);
      });
      row.addEventListener('click', function (e) {
        if (moved) { e.stopPropagation(); e.preventDefault(); moved = false; }
      }, true);
      btns.forEach(function (b, k) {
        b.addEventListener('click', function () {
          if (b.classList.contains('on')) {
            if (b.dataset.href) { clicked = b.dataset.href; location.href = b.dataset.href; }
            else open(f);
          } else center(k, true);
        });
      });
      f.querySelector('.lab').addEventListener('click', function () { open(f); });
    });

    function initFans() {
      [].forEach.call(fans.querySelectorAll('.fan'), function (f) { if (f._init) f._init(); });
    }
    window.addEventListener('load', function () {
      if (document.body.classList.contains('fan-on')) initFans();
    });
    mq.addEventListener('change', apply);

    function apply() {
      var wasOn = document.body.classList.contains('fan-on');
      document.body.classList.toggle('fan-on', mq.matches && g === 'all');
      document.documentElement.classList.remove('fan-pre');
      if (!wasOn && document.body.classList.contains('fan-on')) {
        requestAnimationFrame(initFans);
        setTimeout(initFans, 60);
      }
      [].forEach.call(fans.children, function (f) { f.hidden = !(line === 'all' || f.dataset.line === line); });
      var first = true;
      secs.forEach(function (s) {
        var show = (g === 'all' || s.dataset.g === g) && (line === 'all' || s.dataset.line === line);
        s.hidden = !show;
        s.classList.remove('first');
        if (show && first) { s.classList.add('first'); first = false; }
      });
      document.querySelectorAll('[data-g]').forEach(function (a) {
        if (a.tagName === 'A') a.setAttribute('aria-current', a.dataset.g === g ? 'true' : 'false');
      });
      document.querySelectorAll('.lines button').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.line === line ? 'true' : 'false');
      });
    }

    function fromHash() {
      var h = (location.hash || '#all').slice(1);
      if (['all', 'tees', 'crews', 'hoodies', 'tanks'].indexOf(h) >= 0) g = h;
      else if (h === 'chaz' || h === 'original') { line = h; g = 'all'; }
      apply();
    }

    document.querySelectorAll('a[data-g]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        g = a.dataset.g;
        if (g === 'all') line = 'all';
        history.replaceState(null, '', '#' + g);
        apply();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
    document.querySelectorAll('.lines button').forEach(function (b) {
      b.addEventListener('click', function () { line = b.dataset.line; apply(); });
    });

    /* Back from a product page (browser back or "← The wall") returns to the
       shirt that was clicked, with the same color showing in each phone row */
    var KEY = 'nela-wall-pos';
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.wall a.go, .fans a.go');
      if (a) clicked = a.getAttribute('href');
    }, true);
    function save() {
      try {
        var fs = {};
        [].forEach.call(fans.querySelectorAll('.fan'), function (f) {
          var on = f.querySelector('.row button.on');
          if (on) fs[f.dataset.i] = [].indexOf.call(on.parentNode.children, on);
        });
        sessionStorage.setItem(KEY, JSON.stringify({ y: window.scrollY, line: line, g: g, fans: fs, href: clicked }));
      } catch (e) {}
    }
    window.addEventListener('pagehide', save);
    var st = null;
    try {
      var nv = performance.getEntriesByType('navigation')[0];
      var returning = sessionStorage.getItem('nela-wall-return') === '1';
      sessionStorage.removeItem('nela-wall-return');
      if ((nv && nv.type === 'back_forward') || returning) st = JSON.parse(sessionStorage.getItem(KEY));
    } catch (e) {}
    if (st) {
      line = st.line || 'all';
      if (st.g && !location.hash) history.replaceState(null, '', '#' + st.g);
      [].forEach.call(fans.querySelectorAll('.fan'), function (f) {
        if (st.fans && st.fans[f.dataset.i] != null) f.dataset.start = st.fans[f.dataset.i];
      });
      var back = function () {
        var target = null;
        if (st.href) {
          [].some.call(document.querySelectorAll('a.go, .fans [data-href]'), function (a) {
            var h = a.getAttribute('href') || a.dataset.href;
            if (h === st.href && a.offsetParent !== null) { target = a; return true; }
          });
        }
        if (target) {
          var box = (target.closest('.fan') || target).getBoundingClientRect();
          var y = window.scrollY + box.top - Math.max(0, (window.innerHeight - box.height) / 2);
          window.scrollTo({ top: Math.max(0, y), behavior: 'instant' });
        } else {
          window.scrollTo({ top: st.y, behavior: 'instant' });
        }
      };
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
      requestAnimationFrame(function () {
        back();
        document.documentElement.classList.remove('wall-restoring');
      });
      window.addEventListener('load', function () { setTimeout(back, 0); });
    } else {
      document.documentElement.classList.remove('wall-restoring');
    }

    window.addEventListener('hashchange', fromHash);
    fromHash();
  }

  /* "← The wall" link: tell the wall to return to the clicked shirt. Arriving from the
     Looks page instead, it reads "← Looks" and goes back there (same scroll spot). */
  document.querySelectorAll('[data-wall-return]').forEach(function (a) {
    var from = null;
    try {
      var ref = document.referrer ? new URL(document.referrer) : null;
      if (ref && ref.origin === location.origin && /^\/(?:[a-z]{2}\/)?pages\/looks\/?$/.test(ref.pathname)) from = ref;
    } catch (e) {}
    if (from) {
      a.textContent = a.dataset.looksLabel;
      a.href = from.pathname;
      a.addEventListener('click', function (e) {
        if (history.length > 1) { e.preventDefault(); history.back(); }
      });
      return;
    }
    a.addEventListener('click', function () {
      try { sessionStorage.setItem('nela-wall-return', '1'); } catch (e) {}
    });
  });

  /* Product page: color and size buttons pick the variant; color swaps the photo */
  function initProduct() {
    var root = document.querySelector('[data-pdp]');
    var data = document.querySelector('script[data-variants]');
    if (!root || !data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = root.querySelector('[data-variant-id]');
    var add = root.querySelector('[data-add]');
    var priceEl = root.querySelector('[data-price]');
    var colorName = root.querySelector('[data-color-name]');
    var front = document.getElementById('pdp-front');
    var hasSize = !!root.querySelector('.sz');
    var chosen = {};

    var start = variants.find(function (v) { return String(v.id) === idInput.value; }) || variants[0];
    root.querySelectorAll('.sw[aria-pressed="true"]').forEach(function (b) { chosen.Color = b.dataset.value; });
    if (!chosen.Color && start) {
      var sw = root.querySelector('.sw');
      if (sw) chosen.Color = sw.dataset.value;
    }

    function match() {
      return variants.find(function (v) {
        return Object.keys(chosen).every(function (k) { return v.options.indexOf(chosen[k]) >= 0; });
      });
    }

    function update() {
      root.querySelectorAll('[data-option]').forEach(function (b) {
        b.setAttribute('aria-pressed', chosen[b.dataset.option] === b.dataset.value ? 'true' : 'false');
        if (b.dataset.option === 'Size') {
          var ok = variants.some(function (v) {
            return v.available && v.options.indexOf(b.dataset.value) >= 0 && (!chosen.Color || v.options.indexOf(chosen.Color) >= 0);
          });
          b.disabled = !ok;
        }
      });
      if (colorName && chosen.Color) colorName.textContent = colorLabel(chosen.Color);

      var colorVariant = variants.find(function (v) { return !chosen.Color || v.options.indexOf(chosen.Color) >= 0; });
      if (front && colorVariant && (colorVariant.cutout || colorVariant.image)) {
        front.removeAttribute('srcset');
        front.src = colorVariant.cutout || colorVariant.image;
        front.alt = colorVariant.alt;
      }

      var v = match();
      if (hasSize && !chosen.Size) {
        add.disabled = true;
        add.textContent = add.dataset.labelSelect;
        return;
      }
      if (!v || !v.available) {
        add.disabled = true;
        add.textContent = add.dataset.labelSoldout;
        return;
      }
      idInput.value = v.id;
      priceEl.textContent = v.price;
      add.disabled = add.hasAttribute('data-soon');
      add.textContent = add.dataset.labelAdd;
      history.replaceState(null, '', v.url);
    }

    root.querySelectorAll('[data-option]').forEach(function (b) {
      b.addEventListener('click', function () {
        chosen[b.dataset.option] = b.dataset.value;
        update();
      });
    });
    update();
  }
  /* Contact page: topic chips (?topic= preselects), order field only for order
     questions, message hint per topic, inline validation, sending state. */
  function initContact() {
    var form = document.getElementById('ContactForm');
    if (!form) return;
    var done = form.querySelector('.cf-done');
    if (done) {
      done.focus({ preventScroll: true });
      return;
    }
    if (!form.querySelector('.cf-chips')) return;
    form.noValidate = true;

    var radios = form.querySelectorAll('input[data-topic]');
    var reveals = form.querySelectorAll('[data-for]');
    var msg = form.querySelector('textarea');
    var btn = form.querySelector('button[type="submit"]');
    var label = btn.textContent;

    /* Fields marked data-for="order" or data-for="wholesale collab other"
       show only for those topics */
    function setTopic(first) {
      var r = form.querySelector('input[data-topic]:checked');
      if (!r) return;
      msg.placeholder = r.dataset.hint;
      reveals.forEach(function (f) {
        var show = f.dataset.for.split(' ').indexOf(r.dataset.topic) !== -1;
        if (f.hidden !== show) return;
        f.hidden = !show;
        /* A hidden field isn't sent, even if something was typed in it */
        f.querySelector('input').disabled = !show;
        if (show && !first) {
          f.classList.remove('in');
          void f.offsetWidth;
          f.classList.add('in');
        }
      });
    }
    var want = new URLSearchParams(location.search).get('topic');
    radios.forEach(function (r) {
      if (want && r.dataset.topic === want) r.checked = true;
      r.addEventListener('change', function () { setTopic(false); });
    });
    setTopic(true);

    /* Message box grows with the text */
    function grow() {
      msg.style.height = 'auto';
      msg.style.height = Math.max(msg.scrollHeight + 2, 170) + 'px';
    }
    msg.addEventListener('input', grow);
    if (msg.value) grow();

    var fields = form.querySelectorAll('[required]');
    function check(el) {
      var ok = el.value.trim() !== '' && el.checkValidity();
      var box = el.closest('.cf-field');
      box.classList.toggle('bad', !ok);
      el.setAttribute('aria-invalid', ok ? 'false' : 'true');
      box.querySelector('.cf-msg').textContent = ok ? '' : el.dataset.msg;
      return ok;
    }
    fields.forEach(function (el) {
      el.addEventListener('blur', function () { if (el.value.trim() !== '' || el.dataset.touched) check(el); });
      el.addEventListener('input', function () {
        el.dataset.touched = '1';
        if (el.closest('.cf-field').classList.contains('bad')) check(el);
      });
    });

    form.addEventListener('submit', function (e) {
      var firstBad = null;
      fields.forEach(function (el) {
        if (!check(el) && !firstBad) firstBad = el;
      });
      if (firstBad) {
        e.preventDefault();
        firstBad.focus();
        return;
      }
      btn.disabled = true;
      btn.textContent = btn.dataset.busy;
    });
    /* Coming back with the browser's back button: make the button usable again */
    window.addEventListener('pageshow', function () {
      btn.disabled = false;
      btn.textContent = label;
    });
  }
  /* "¿Prefieres español?": English site, Spanish-language phone/browser, no earlier choice.
     The choice (yes or no) is remembered so the bar never nags. */
  function initLangPrompt() {
    var bar = document.querySelector('[data-lang-prompt]');
    if (!bar) return;
    var KEY = 'nela-lang-choice';
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    if (saved) return;
    var langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
    if (!/^es\b/i.test(langs[0] || '')) return;
    function remember(v) {
      try { localStorage.setItem(KEY, v); } catch (e) {}
    }
    var root = bar.dataset.esRoot.replace(/\/$/, '');
    var yes = bar.querySelector('[data-lang-yes]');
    yes.href = root + location.pathname + location.search + location.hash;
    yes.addEventListener('click', function () { remember('es'); });
    bar.querySelector('[data-lang-no]').addEventListener('click', function () {
      remember('en');
      bar.hidden = true;
    });
    /* The ES button in the header counts as a choice too */
    document.querySelectorAll('.lang-form').forEach(function (f) {
      f.addEventListener('submit', function () { remember('switched'); });
    });
    setTimeout(function () { bar.hidden = false; }, 1200);
  }
})();
